<script type="text/jsx">
import ParticipantsDiffPopover from '@/plans/LARGE_MEETING/component/participants-diff-popover.vue';
import planCommonMixin from '@/plans/WEBINAR/mixin';
import PlanDetailsMixin from '@/plans/EVENT_SAAS/component/dialog/plan-details/mx-plan-details';
import ConfigBase from '@/components/config-base';
import { toLowercaseString } from '@/common/utils';

export default {
  name: 'ConfigBase',
  extends: ConfigBase,
  mixins: [planCommonMixin, PlanDetailsMixin],
  components: { ParticipantsDiffPopover },
  data() {
    return {
      orderByKey: "capacity",
    };
  },
  computed: {
    maxCapacityDesc() {
      return toLowercaseString(this.orderSelectedPlansByDesc[0]?.capacityDesc) || this.$t('billing.event_services.unit.million_1_uppercase');
    },
    configDesc(){
      if (this.$context.is.switch) {
        return this.$t('billing.webinar.engage_your_audiences_desc');
      }
      return `${this.$t('billing.webinar.engage_your_audiences_desc')} ${this.$t('billing.webinar.up_to_x_attendees_y_panelists', [this.maxCapacityDesc,100])}`;
    }
  },
  methods: {
    mx_renderConfigDesc() {
      return this.$slots.configDesc ?
        this.$slots.configDesc :
        (<p class="opc-addon-config__main__title">
        <span>{this.configDesc}</span>
        <participants-diff-popover type={this.planType} />
      </p>);
    },
  },
};
</script>
